"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var Button_1 = require("./Button");

var Button = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background: transparent;\n  border: none;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n"], ["\n  position: relative;\n  background: transparent;\n  border: none;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n"])));
var Menu = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  right: ", ";\n  left: ", ";\n  margin: 0;\n  z-index: 1;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", "px;\n  display: flex;\n  flex-direction: column;\n  padding: 4px 0;\n"], ["\n  position: absolute;\n  top: 100%;\n  right: ", ";\n  left: ", ";\n  margin: 0;\n  z-index: 1;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", "px;\n  display: flex;\n  flex-direction: column;\n  padding: 4px 0;\n"])), function (_a) {
  var align = _a.align;
  return align === 'right' ? 0 : 'auto';
}, function (_a) {
  var align = _a.align;
  return align === 'right' ? 'auto' : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.surface.color;
}, function (_a) {
  var theme = _a.theme;
  return theme.card.boxShadow;
}, function (_a) {
  var theme = _a.theme;
  return theme.card.borderRadius;
});
exports.MenuItem = styled_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: transparent;\n  padding: ", ";\n  border: 0;\n  cursor: pointer;\n  white-space: nowrap;\n  text-align: left;\n  font-size: 14px;\n"], ["\n  background: transparent;\n  padding: ", ";\n  border: 0;\n  cursor: pointer;\n  white-space: nowrap;\n  text-align: left;\n  font-size: 14px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.default.padding / 2 + "px " + theme.default.padding + "px";
});
var StyledDropdown = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));

exports.DropdownMenu = function (_a) {
  var _b;

  var menu = _a.menu,
      children = _a.children,
      align = _a.align,
      history = _a.history,
      items = _a.items,
      isIcon = _a.isIcon,
      isOpen = _a.isOpen,
      onToggle = _a.onToggle,
      props = __rest(_a, ["menu", "children", "align", "history", "items", "isIcon", "isOpen", "onToggle"]);

  var node = react_1.useRef(null);

  var _c = react_1.useState(false),
      internalOpen = _c[0],
      setInternalOpen = _c[1];

  var handleClickOutside = function handleClickOutside(e) {
    if (node && node.current && node.current.contains(e.target)) {
      // inside click
      return;
    } // outside click


    if (onToggle) {
      onToggle(false);
    } else {
      setInternalOpen(false);
    }
  };

  var checkIsOpen = function checkIsOpen() {
    return onToggle ? isOpen : internalOpen;
  };

  react_1.useEffect(function () {
    if (checkIsOpen()) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [internalOpen, isOpen]);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (onToggle) {
      onToggle(!checkIsOpen());
    } else {
      setInternalOpen(!checkIsOpen());
    }
  };

  return react_1.default.createElement(StyledDropdown, {
    ref: node
  }, isIcon ? react_1.default.createElement(Button_1.IconButton, __assign({
    onClick: handleClick
  }, props), children) : react_1.default.createElement(Button, __assign({
    onClick: handleClick
  }, props), children), internalOpen && react_1.default.createElement(Menu, {
    align: align
  }, ((_b = items) === null || _b === void 0 ? void 0 : _b.map(function (_a, index) {
    var label = _a.label,
        _onClick = _a.onClick;
    return react_1.default.createElement(exports.MenuItem, {
      key: index,
      onClick: function onClick(e) {
        _onClick(e);

        if (onToggle) {
          onToggle(false);
        } else {
          setInternalOpen(false);
        }
      }
    }, label);
  })) || menu && menu()));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;